import { toast, ToastOptions } from 'react-toastify';

export function useNotification() {
  const config: ToastOptions = {
    position: 'top-right',
    autoClose: 800,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: false,
  };

  return {
    successNotification: (msg: string) => toast.success(msg, config),
    errorNotification: (msg: string) => toast.error(msg, config),
  };
}
